export const COMPANY_DATA = { id: 1, name: "GluonCode." };

export const HOME_DATA = {
  header:
    "Revolutionizing Software Development and Maintenance for the Modern Business",
  subHeader: "Grow with us.",
  information: [
    "Speedy, adaptive software development for businesses",
    "Quick, flexible software engineering solutions",
    "Agile, customizable software design and build services",
  ],
  description:
    "We provide innovative software solutions that drive business growth and efficiency through expert development and maintenance services.",
};

export const ABOUT_DATA = {
  header: "The Premier Software Development Company",

  description: `<p>
    We are a professional and experienced software development company
    that specializes in creating complex enterprise software solutions
    that meet the unique needs of your business.
  </p>
  <br/>
  <p>
    Our team of expert developers have a deep understanding of the
    latest technologies and development techniques, which allows us to
    provide you with cutting-edge solutions that will help drive
    growth and set you apart from the competition.
  </p>
  <br/>
  <p>
    We understand the importance of reliable software integration and
    are committed to modernizing your legacy systems to ensure they
    are up-to-date and functioning at their best. Whether you're
    looking to create a new system or upgrade an existing one, we have
    the skills and experience to help you achieve your goals.
  </p>
  <br/>
  <p>
    Our goal is to provide you with the most effective and efficient
    solutions to help your business succeed.
  </p>`,

  detailedDescription: `<p>As a premier software development company, we are dedicated to providing expert and professional software solutions that meet the unique needs of your business. Our team of highly skilled and experienced developers has a deep understanding of the latest technologies and development methodologies, allowing us to deliver cutting-edge solutions that will set your business apart from the competition.</p>
  <br/>
  <p>We understand that reliable software integration is crucial for the success of your business, which is why we are committed to modernizing your legacy systems to ensure they are functioning at their best. Whether you are looking to create a new system or upgrade an existing one, our team has the expertise and experience to help you achieve your goals.</p>
  <br/>
  <p>Our goal is to provide you with the most effective and efficient solutions that will help your business succeed and thrive in today's fast-paced and highly competitive market. We believe in delivering software solutions that are tailored to meet your specific business needs and objectives, and our team is always available to provide guidance and support along the way.</p>
  <br/>
  <p>We are committed to delivering software solutions that are of the highest quality, and we work closely with our clients to ensure that their needs and expectations are met. Our focus is always on providing the best possible software solutions to help our clients achieve their goals and succeed in their respective industries.</p>`,
};

export const NAVBAR_DATA = [
  {
    id: 1,
    name: "Home",
    url: "/",
    scrollTo: "home",
  },
  {
    id: 2,
    name: "About",
    scrollTo: "about",
  },
  { id: 3, name: "Services", scrollTo: "services" },
  { id: 4, name: "Our Work", scrollTo: "portfolio" },
  { id: 5, name: "Contact", scrollTo: "contact" },
];

export const PORTFOLIO_IMAGES = [
  {
    id: 1,
    imageUrl:
      "https://mms.businesswire.com/media/20220802006074/en/1532617/23/logo-t_%281%29.jpg",
    imageUrlDesc:
      "https://mms.businesswire.com/media/20220802006074/en/1532617/23/logo-t_%281%29.jpg",
    imageUrlSide:
      "https://buy.rubikhomes.com/static/media/next-deal.5e7e5d4f.png",
    name: "Rubik",
    title: "Rubik RealEstate E-Commerce",
    description: `<p>The RubikEstate app, built for Rubik, is a state-of-the-art platform for managing and optimizing real estate assets. This app offers a comprehensive solution for real estate professionals, providing a central location to manage properties, monitor performance, and make informed decisions. With the RubikEstate app, real estate managers can easily track key metrics, such as occupancy rates, rental income, and expenses. The app also features advanced analytics tools, allowing users to analyze data, identify trends, and make informed decisions to optimize their real estate investments. Whether you're managing a small portfolio or a large real estate portfolio, the RubikEstate app is a valuable tool for real estate professionals looking to improve the performance of their assets. The app provides the flexibility, transparency, and insights needed to make informed decisions, drive growth, and maximize returns.</p>`,
    imageWidth: "600px",
    imageHeight: "auto",
  },
  {
    id: 2,
    imageUrl: "https://miro.medium.com/max/870/1*4R1ntbIUt-sm5MIRJWHC1A.png",
    imageUrlDesc:
      "https://static.wixstatic.com/media/d42003_0258104065ff45be9aaafffbdcb58692~mv2.png/v1/fill/w_418,h_503,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/inkitt%20logo.png",
    imageUrlSide:
      "https://static.wixstatic.com/media/d42003_9192730a347b4cce8863eb99d7200529~mv2.png/v1/fill/w_842,h_589,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/iPhone%2012%20Pro.png",
    imageUrl2:
      "https://static.wixstatic.com/media/d42003_60cab7dd1007440eb4d791597189246c~mv2.png/v1/fill/w_422,h_589,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/iPhone%2013%20Pro.png",
    name: "Inkitt",
    title: "Inkitt Book Reader",
    description: `<p>
    Inkitt is a unique platform that aims to uncover and support
    talented writers from all over the world. It provides authors
    with a space to showcase their writing and submit their works
    for publication. With the goal of helping writers achieve
    their aspirations, whether it be professional publication or
    becoming part of a large writing and reading community.
  </p>
  <br />
  <p>
    As part of their efforts, Inkitt collaborated with a team to
    develop their flagship app, Galatea. Galatea is a premium
    version of the Inkitt platform and offers users the
    opportunity to spend their points to continue reading
    captivating stories. This app provides an enhanced reading
    experience, allowing users to immerse themselves in the world
    of fiction and discover new and talented writers.
  </p>`,
    imageWidth: "400px",
    imageHeight: "auto",
  },
  {
    id: 3,
    imageUrl:
      "https://sosumed.com/wp-content/uploads/2015/02/talentwunderx505x235.jpg",
    imageUrlDesc:
      "https://www.hr-software-vergleich.de/wp-content/uploads/2021/07/logo_talentwunder.png",
    imageUrlSide:
      "https://talentwunder.com/wp-content/uploads/2021/10/TW-App_Allgemein_People_3.webp",
    name: "TalentWunder",
    title: "TalentWunder Recruit Management System",
    description: `<p>The TalentWunder recruitment app is a comprehensive solution for companies looking to streamline their hiring process and find top talent. The app is designed to make the recruitment process more efficient, by offering advanced tools and a user-friendly interface. With TalentWunder, companies can quickly find and engage with the most qualified candidates, based on skills, experience, and culture fit. The app also includes features for HR teams to manage candidate communications, schedule interviews, and track the progress of each hiring process. By using the TalentWunder recruitment app, companies can save time and resources while finding the best candidates for their open positions. Whether you're a small start-up or a large enterprise, the TalentWunder app is a valuable tool for companies looking to improve their recruitment process and find the talent they need to succeed.</p>`,
    imageWidth: "800px",
    imageHeight: "auto",
  },
  {
    id: 4,
    imageUrl:
      "https://scontent.fprn1-1.fna.fbcdn.net/v/t39.30808-6/295407185_464750892320862_6642186987990065191_n.jpg?_nc_cat=108&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=vToXFQL4jNEAX_ntcd6&_nc_ht=scontent.fprn1-1.fna&oh=00_AfBvi-nXpNaYZob2VuEzFlH603C6SjQ2RxKtbNJULnZMlQ&oe=63E89B10",
    imageUrlDesc:
      "https://portal.corescaffold.com/static/media/core_logo.acb406b5db1bf0e6bcd7c521a0403330.svg",
    imageUrlSide: "",
    name: "CoreScaffold",
    title: "CoreScaffold Project Management",
    description: `<p>CoreScaffold Project Management App is a powerful construction project management platform that is designed to streamline all aspects of construction project management. As a construction company, CoreScaffold use this Project Management App to manage their projects, including schedules, tasks, charges, invoicing, fleet, inspections etc. With this App, their construction engineers have a centralized location to manage projects, collaborate with team members, and ensure that all tasks are completed on time and within budget. The platform's advanced features make it easy to manage the financial and operational aspects of a construction project, freeing up their time to focus on building and delivering the best possible results for their clients. Whether they're managing a large-scale project or a smaller renovation.</p<`,
    imageWidth: "800px",
    imageHeight: "auto",
  },
];

export const SERVICES_DATA = [
  {
    id: 1,
    title: "Software Development to Boost <br /> Business Growth",
    description:
      "We are a dedicated and skilled team of software developers who are passionate about creating solutions that drive business growth.",
    customCSS: "",
  },
  {
    id: 2,
    title: "Our Development Strategy",
    description:
      "We focus on creating software that is tailored to your unique business needs, using cutting-edge technologies and development techniques to ensure optimal performance and scalability.",
    customCSS: "bg-gray-100 md:my-0 my-8",
  },
  {
    id: 3,
    title: "B2B Software Development",
    description:
      "We specialize in creating custom software solutions for other businesses, helping them to streamline their processes and unlock their full potential.",
    customCSS: "",
  },
];

export const CONTACT_DATA = {
  tel: "+383 49 000 000",
  email: "info@gluoncode.com",
};
